
import React from "react";
import { Accordion, AccordionPanel, Panel } from '@ronuse/norseu/core/panels';
import Helpers from "../../../utils/Helpers";
import { Button } from "@ronuse/norseu/core/buttons";
import { Dialog } from "@ronuse/norseu/core/overlay";
import { Position, Scheme } from "@ronuse/norseu/core/variables";
import { Checkbox, Dropdown, InputText, PasswordInput } from "@ronuse/norseu/core/form";

export class DialogPage extends React.Component {

    constructor(props) {
        super(props);
        this.willUnmount = false;
        this.previewPanels = React.createRef();
        this.previewPanels.current = [];
        this.emailRef = React.createRef();
        this.focusButtonRef = React.createRef();
    }

    componentWillUnmount() {
        this.willUnmount = true;
    }

    static basicText() {
        return `
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut 
            labore et dolore magna aliqua. Morbi tempus iaculis urna id. Ut ornare lectus 
            sit amet est placerat in egestas. Sit amet mauris commodo quis imperdiet massa. 
            Dictum sit amet justo donec enim diam vulputate ut pharetra.
        `;
    }

    static overflowText() {
        return DialogPage.basicText().repeat(20);
    }

    renderFooter(name) {
        return (
            <div>
                <Button text="Cancel" icon="fa fa-times" textOnly scheme={Scheme.DANGER} onClick={() => this.setState({[`${name}`]: false})} />
                <Button text="Continue" icon="fa fa-check" scheme={Scheme.PRIMARY} onClick={() => this.setState({[`${name}`]: false})}/>
            </div>
        )
    }

    onHide(name) {
        this.setState({
            [`${name}`]: false
        });
    }
    
    static formControls(ref, onClick) {
        return (
            <div style={{ margin: "0px 10px", display: "flex", flexDirection: "column" }}>
                <InputText style={{ marginTop: "15px" }} ref={ref} scheme={Scheme.PRIMARY} label="Email" placeholder="Enter your email address"/>
                <PasswordInput style={{ marginTop: "15px" }} scheme={Scheme.PRIMARY} label="Password" placeholder="Enter your email address"/>
                <Checkbox style={{ marginTop: "15px" }} scheme={Scheme.PRIMARY} label="Stay Signed in"/>
                <div style={{marginTop: "15px"}}>
                    <Button text="Close" onClick={onClick}/>
                    <Button scheme={Scheme.SUCCESS} text="Submit" onClick={onClick}/>
                </div>
            </div>
        );
    }

    buildDocumentation() {
        const dialogPositions = [
            { label: "Position.LEFT", value: Position.LEFT },
            { label: "Position.RIGHT", value: Position.RIGHT },
            { label: "Position.CENTER", value: Position.CENTER },
            { label: "Position.TOP", value: Position.TOP },
            { label: "Position.TOP_CENTER", value: Position.TOP_CENTER },
            { label: "Position.TOP_LEFT", value: Position.TOP_LEFT },
            { label: "Position.TOP_RIGHT", value: Position.TOP_RIGHT },
            { label: "Position.BOTTOM", value: Position.BOTTOM },
            { label: "Position.BOTTOM_CENTER", value: Position.BOTTOM_CENTER },
            { label: "Position.BOTTOM_LEFT", value: Position.BOTTOM_LEFT },
            { label: "Position.BOTTOM_RIGHT", value: Position.BOTTOM_RIGHT },
        ];

        return (
            <React.Fragment>
                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Basic</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <Button text="Show Basic" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={() => this.setState({showBasic: true})} />
                            <Button text="Show With Long Content" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={() => this.setState({showOverflow: true})} />

                            <Dialog header="Basic" isVisible={this.state.showBasic} onHide={(e) => this.onHide('showBasic')} footer={this.renderFooter('showBasic')}>
                                <p>{DialogPage.basicText()}</p>
                            </Dialog>

                            <Dialog header="Overflow Content" isVisible={this.state.showOverflow} onHide={(e) => this.onHide('showOverflow')} footer={this.renderFooter('showOverflow')}>
                                <p>{DialogPage.overflowText()}</p>
                            </Dialog>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Header and Footer</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            
                            <Button text="Show Custom Header Dialog" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={() => this.setState({ showCustomHeader: true})} />
                            <Dialog header={
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <img alt="norseu" src="https://avatars3.githubusercontent.com/u/14879387?s=16" style={{ borderRadius:"50%", height: 40 }}/>
                                    <span style={{ marginLeft: 10 }}>Custom Header</span>
                                </div>}
                                isVisible={this.state.showCustomHeader}
                                onHide={(e) => this.onHide('showCustomHeader')}>
                                <p>{DialogPage.basicText()}</p>
                            </Dialog>
                            
                            <Button text="Show Custom Footer Dialog" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={() => this.setState({ showCustomFooter: true})} />
                            <Dialog footer={
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <img alt="norseu" src="https://avatars3.githubusercontent.com/u/14879387?s=16" style={{ borderRadius:"50%", height: 40 }}/>
                                    <span style={{ marginLeft: 10 }}>Custom Header</span>
                                </div>}
                                noHeader isVisible={this.state.showCustomFooter}
                                onHide={(e) => this.onHide('showCustomFooter')}>
                                <p>{DialogPage.basicText()}</p>
                            </Dialog>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">onOpen and onClose Focus</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            
                            <Button text="Show Focus Dialog" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={() => this.setState({ showFocusDialog: true})} />
                            <Dialog header="Focus Dialog"
                                onOpenFocusRef={this.emailRef}
                                style={{ width: "fit-content" }}
                                onCloseFocusRef={this.focusButtonRef}
                                isVisible={this.state.showFocusDialog}
                                onHide={(e) => this.onHide('showFocusDialog')}>
                                {DialogPage.formControls(this.emailRef, (e) => this.onHide('showFocusDialog'))}
                            </Dialog>
                            <Button ref={this.focusButtonRef} text="Focus on dialog close"/>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Props</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <Button text="Maximizable" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={() => this.setState({showMaximizable: true})} />
                            <Button text="Without Modal" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={() => this.setState({showWithoutModal: true})} />
                            <Button text="Without Header And Footer" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={() => this.setState({showWithoutHeaderAndFooter: true})} />
                            
                            <Dialog maximizeIcons={{
                                maximize: <i className="fa fa-plus"></i>,
                                minimize: <i className="fa fa-minus"></i>,
                            }} header="Maximizable" maximizable isVisible={this.state.showMaximizable} onHide={(e) => this.onHide('showMaximizable')} footer={this.renderFooter('showMaximizable')}>
                                <p>{DialogPage.overflowText()}</p>
                            </Dialog>

                            <Dialog header="Without Modal" noOverlay isVisible={this.state.showWithoutModal} onHide={(e) => this.onHide('showWithoutModal')} footer={this.renderFooter('showWithoutModal')}>
                                <p>{DialogPage.basicText()}</p>
                            </Dialog>

                            <Dialog header="Without Header And Footer" noHeader isVisible={this.state.showWithoutHeaderAndFooter} onHide={(e) => this.onHide('showWithoutHeaderAndFooter')}>
                                <p>{DialogPage.basicText()}</p>
                            </Dialog>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Position</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <Dropdown options={dialogPositions} selectedOptionIndex={2} onSelectOption={(e) => this.setState({ dialogPosition: e.option.value } )}/>
                            <br/>
                            <Button text="Show" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} onClick={() => this.setState({ showWithPosition: true})} />
                            <Dialog header={`Position ${this.state.dialogPosition}`} position={this.state.dialogPosition} isVisible={this.state.showWithPosition} onHide={(e) => this.onHide('showWithPosition')} footer={this.renderFooter('showWithPosition')}>
                                <p>{DialogPage.basicText()}</p>
                            </Dialog>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>
            </React.Fragment>
        );
    }

    render() {
        return Helpers.buildComponentPage(this, {
            title: "Dialog",
            import_statement: "import { Dialog } from '@ronuse/norseu/core/overlay'",
            properties: DialogPage.properties,
            css_map: this.cssMap,
            ref_map: DialogPage.refMap,
            documentation: this.buildDocumentation(),
            page_source: this.state.pageSource,
            show_dialog: this.state.showSourceDialog,
            source_url: "https://raw.githubusercontent.com/ronuse/norseu/main/showcase/src/components/core/overlay/DialogPage.js"
        });
    }

    state = {
        pageSource: '',
        dialogPosition: Position.CENTER,
        showSourceDialog: false
    };

    cssMap = [

    ];

    static properties = [
        { name: "isVisible", type: "boolean", default: false, description: "If true the dialog and it modal will be rendered in DOM" },
        { name: "position", type: <a href='#/p/components/core/variables/position'>Position</a>, default: <a href='#/p/components/core/variables/position#center'>Position.CENTER</a>, description: "The position pop in the dialog from for transition animation" },
        { name: "dismissableModal", type: "boolean", default: true, description: "Remove/hide the dialog when the modal is clicked" },
        { name: "noOverlay", type: "boolean", default: false, description: "Prevent rendering the dialog modal" },
        { name: "className", type: "string", default: null, description: "CSS classes to apply to the dialog compound element" },
        { name: "style", type: "object", default: null, description: "CSS Style to apply to the dialog compound element" },
        { name: "modalClassName", type: "string", default: null, description: "CSS classes to apply to the dialog modal element" },
        { name: "modalStyle", type: "object", default: null, description: "CSS Style to apply to the dialog modal element" },
        { name: "contentClassName", type: "string", default: null, description: "CSS classes to apply to the dialog content element" },
        { name: "contentStyle", type: "object", default: null, description: "CSS Style to apply to the dialog content element" },
        { name: "transitionOptions", type: "object", default: "", description: "React transition group option for the dialog body" },
        { name: "allowScroll", type: "boolean", default: true, description: "Allow the document body to receive scroll event when the dialog is visible" },
        { name: "maximizable", type: "boolean", default: false, description: "Render the miximize button to make the dialog body full screen" },
        { name: "maximized", type: "boolean", default: false, description: "Make the dialog body full screen on show/render" },
        { name: "maximizeIcons", type: "object", default: {
            maximize: "fa fa-window-maximize",
			minimize: "fa fa-window-minimize",
        }, description: "The maximize and minimize icon/element for the dialog. Value of minimize and maximize can be font awesome class or a react element" },
        { name: "notClosable", type: "boolean", default: false, description: "Prevent rendering the close button in the header" },
        { name: "closeIcon", type: "string|element", default: "fa fa-times", description: "The header close button, can be font awesome class name or a react element" },
        { name: "header", type: "string|element", default: null, description: "The dialog header, can be font awesome class name or a react element" },
        { name: "footer", type: "string|element", default: null, description: "The dialog footer, can be font awesome class name or a react element" },
        { name: "noHeader", type: "boolean", default: false, description: "Prevent rendering the dialog header and the close element" },
        { name: "onOpenFocusRef", type: "React.Ref", default: null, description: "The component ref that receive focus once the dialog is visible in DOM" },
        { name: "onCloseFocusRef", type: "React.Ref", default: null, description: "The component ref that receive focus once the dialog is removed from DOM" },
        { name: "baseZIndex", type: "number", default: 1001, description: "The base z-index of the dialog" },
        { name: "container", type: "element", default: "document.body", description: "The parent element to render the dialog in" },
        { name: "onShow", type: "function", default: "(event)", description: "The callback that is invoked when the dialog is visible in DOM" },
        { name: "onHide", type: "function", default: "(event)", description: "The callback that is invoked when the dialog is removed from the DOM" },
        { name: "onMaximize", type: "function", default: "(options)", description: "The callback that is invoked when the dialog is maximized or minimized" },
    ];
    
    static refMap = [
        { name: "getInternalElement()", type: "function", description: "Get the react reference to the internal element" },
        { name: "getState()", type: "function", description: "Get the current state of the component" },
        { name: "setState(newState)", type: "function", description: "Change the component state" },
    ]

}
